import { Fragment } from "react"

// ** Third Party Components
import { ChevronLeft } from "lucide-react"

// ** UI Components
import { Button } from "@components/common/button"

// ** Constants
import { BREADCRUMBS_OVERFLOW_LIMIT } from "@pma/utils/constants"

// ** Custom Hooks
import { useFilesView } from "@pma/hooks/use-files-view"

export default function BreadcrumbsNav() {
  const { activeFolder, breadcrumbs, handleTreeItemFolderClick } = useFilesView()

  const crumbs = breadcrumbs[activeFolder?.id]
  if (!crumbs || crumbs.length === 0) return null

  return (
    <div className="mx-2 flex items-center gap-1 font-semibold">
      {/* Back button */}
      {crumbs.length > 1 && (
        <Button
          variant="link"
          className="p-0"
          onClick={() => handleTreeItemFolderClick(crumbs[crumbs.length - 2], true)}
        >
          <ChevronLeft />
        </Button>
      )}

      {/* Overflow indicator */}
      {crumbs.length > BREADCRUMBS_OVERFLOW_LIMIT && (
        <Button variant="disabled" className="bg-transparent p-0">
          {"..."}
        </Button>
      )}

      {/* Breadcrumb items */}
      {crumbs.map((bread, index) => {
        if (index <= crumbs.length - 1 - BREADCRUMBS_OVERFLOW_LIMIT) return null

        const isLast = index === crumbs.length - 1
        const separator = index > 0 ? " / " : ""

        return (
          <Fragment key={`${bread.name}-${index}`}>
            {separator}
            {isLast ? (
              <Button variant="disabled" className="bg-transparent p-0">
                {bread.name ?? ""}
              </Button>
            ) : (
              <Button
                variant="link"
                className="p-0"
                onClick={() => handleTreeItemFolderClick(bread, true)}
              >
                {bread.name ?? ""}
              </Button>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}